import { render, staticRenderFns } from "./alert-notification.vue?vue&type=template&id=5f29d6de&scoped=true&"
import script from "./alert-notification.vue?vue&type=script&lang=ts&"
export * from "./alert-notification.vue?vue&type=script&lang=ts&"
import style0 from "./alert-notification.vue?vue&type=style&index=0&id=5f29d6de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f29d6de",
  null
  
)

export default component.exports